export default __webpack_public_path__ + "top_bknmsg.8aae15.jpg";